<template>
	<section class="provider-profile-page">
		<div class="profile-summary">
			<div class="avatar-wrap"><img src="@/assets/user/user-avator.png" alt="用户头像" /></div>
			<div class="summary-copy">
				<div class="summary-title">
					<h2>{{ userForm.realName || '服务商用户' }}</h2>
					<span>
						<i class="el-icon-circle-check"></i>
						账号正常
					</span>
				</div>
				<p>{{ userForm.userName ? `登录账号：${userForm.userName}` : '服务商个人资料' }}</p>
			</div>
		</div>

		<div class="profile-card">
			<div class="card-heading">
				<div>
					<h3>个人资料</h3>
					<p>管理您的基础信息与账号安全设置</p>
				</div>
			</div>

			<el-form label-width="140px" class="profile-form">
				<el-form-item label="昵称">
					<div class="form-value">
						<el-input v-model="userForm.realName" disabled></el-input>
						<el-button type="text" @click="handleUpdateUserInfo('2')">修改</el-button>
					</div>
				</el-form-item>
				<el-form-item label="手机号">
					<div class="form-value">
						<el-input v-model="userForm.phone" disabled></el-input>
						<el-button type="text" @click="handleUpdateUserInfo('3')">更换</el-button>
					</div>
				</el-form-item>
				<el-form-item label="邮箱">
					<div class="form-value">
						<el-input v-model="userForm.email" disabled></el-input>
						<el-button type="text" @click="handleUpdateUserInfo('5')">
							{{ userForm.email && userForm.email !== '未绑定' ? '修改' : '绑定邮箱' }}
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="登录密码">
					<div class="form-value">
						<el-input v-model="userForm.password" type="password" disabled></el-input>
						<el-button type="text" @click="handleUpdateUserInfo('4')">修改</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>

		<jr-dialog :title="dialogTitle" :visible.sync="updateVisible" width="620px" @close="handleCloseDialog">
			<template slot="content">
				<el-form ref="updateForm" :model="updateForm" :rules="rules" label-width="130px">
					<el-form-item v-if="updateType === '2'" label="昵称：" prop="realName">
						<el-input v-model.trim="updateForm.realName" placeholder="请输入昵称"></el-input>
					</el-form-item>

					<template v-else-if="updateType === '3'">
						<el-form-item label="登录密码：" prop="password">
							<el-input v-model="updateForm.password" type="password" placeholder="请输入登录密码"></el-input>
						</el-form-item>
						<el-form-item label="新手机号：" prop="phone">
							<el-input v-model.trim="updateForm.phone" placeholder="请输入新手机号"></el-input>
						</el-form-item>
					</template>

					<template v-else-if="updateType === '4'">
						<el-form-item label="原密码：" prop="password">
							<el-input v-model="updateForm.password" type="password" placeholder="请输入原密码"></el-input>
						</el-form-item>
						<el-form-item label="新密码：" prop="newPassword1">
							<el-input v-model="updateForm.newPassword1" type="password" placeholder="请输入6-18位数字字母新密码"></el-input>
						</el-form-item>
						<el-form-item label="确认密码：" prop="newPassword2">
							<el-input v-model="updateForm.newPassword2" type="password" placeholder="请再次输入新密码"></el-input>
						</el-form-item>
					</template>

					<template v-else-if="updateType === '5'">
						<el-form-item label="登录密码：" prop="password">
							<el-input v-model="updateForm.password" type="password" placeholder="请输入登录密码"></el-input>
						</el-form-item>
						<el-form-item label="邮箱：" prop="email">
							<el-input v-model.trim="updateForm.email" placeholder="请输入邮箱"></el-input>
						</el-form-item>
					</template>
				</el-form>
			</template>
			<template slot="footer">
				<el-button @click="updateVisible = false">取消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="handleSave">确定</el-button>
			</template>
		</jr-dialog>
	</section>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { getUserInfo } from '@/api/userCenter'
	import { updateUser } from '@/api/user'
	import { validatePassword, validateMobile, validateEmail } from '@/utils/jr-validate'
	import JrDialog from '@/components/Dialog'
	import defaultSettings from '@/settings'

	const createUpdateForm = () => ({
		realName: '',
		phone: '',
		email: '',
		password: '',
		newPassword1: '',
		newPassword2: ''
	})

	export default {
		name: 'ProviderProfile',
		components: { JrDialog },
		data() {
			const validateConfirmPassword = (rule, value, callback) => {
				if (value !== this.updateForm.newPassword1) callback(new Error('两次输入密码不一致'))
				else callback()
			}

			return {
				userForm: {
					id: '',
					userName: '',
					realName: '',
					phone: '',
					email: '未绑定',
					password: '****************'
				},
				updateVisible: false,
				updateType: '',
				updateForm: createUpdateForm(),
				submitLoading: false,
				rules: {
					realName: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{ validator: validateMobile, trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请输入邮箱', trigger: 'blur' },
						{ validator: validateEmail, trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' },
						{ validator: validatePassword, trigger: 'blur' }
					],
					newPassword1: [
						{ required: true, message: '请输入新密码', trigger: 'blur' },
						{ validator: validatePassword, trigger: 'blur' }
					],
					newPassword2: [
						{ required: true, message: '请再次输入新密码', trigger: 'blur' },
						{ validator: validateConfirmPassword, trigger: 'blur' }
					]
				}
			}
		},
		computed: {
			...mapGetters(['userInfo']),
			dialogTitle() {
				return {
					'2': '修改昵称',
					'3': '更换手机号',
					'4': '修改密码',
					'5': '绑定邮箱'
				}[this.updateType]
			}
		},
		mounted() {
			this.applyUserInfo(this.userInfo)
			this.loadUserInfo()
		},
		methods: {
			applyUserInfo(data = {}) {
				const sysUser = data.sysUserVO || {}
				this.userForm.id = data.id || sysUser.id || this.userForm.id
				this.userForm.userName = sysUser.userName || data.userName || this.userForm.userName
				this.userForm.realName = data.realName || sysUser.realName || this.userForm.realName
				this.userForm.phone = data.phone || sysUser.phone || this.userForm.phone
				this.userForm.email = sysUser.email || data.email || '未绑定'
			},
			loadUserInfo() {
				getUserInfo()
					.then(response => this.applyUserInfo(response.data || {}))
					.catch(() => {})
			},
			handleUpdateUserInfo(type) {
				this.updateType = type
				this.updateForm = createUpdateForm()
				if (type === '2') this.updateForm.realName = this.userForm.realName
				if (type === '5' && this.userForm.email !== '未绑定') this.updateForm.email = this.userForm.email
				this.updateVisible = true
			},
			handleCloseDialog() {
				this.$refs.updateForm && this.$refs.updateForm.resetFields()
			},
			handleSave() {
				this.$refs.updateForm.validate(valid => {
					if (!valid) return
					this.submitLoading = true
					updateUser({
						updateType: this.updateType,
						user: {
							id: this.userForm.id,
							userName: this.userForm.userName,
							...this.updateForm
						}
					})
						.then(() => {
							this.$message.success('修改成功')
							this.updateVisible = false
							if (this.updateType === '2' || this.updateType === '5') {
								this.$store.dispatch('user/getUserInfo')
								this.loadUserInfo()
							} else {
								this.$store.dispatch('user/logout').then(() => {
									window.location.href = defaultSettings.publicPath + 'login'
								})
							}
						})
						.finally(() => {
							this.submitLoading = false
						})
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.provider-profile-page {
		min-height: 100%;
		box-sizing: border-box;
	}

	.profile-summary,
	.profile-card {
		border: 1px solid #e4e9ef;
		border-radius: 8px;
		background: #ffffff;
		box-shadow: 0 5px 18px rgba(35, 64, 99, 0.04);
	}

	.profile-summary {
		display: flex;
		align-items: center;
		padding: 25px 28px;
	}

	.avatar-wrap {
		width: 72px;
		height: 72px;
		margin-right: 19px;
		overflow: hidden;
		border: 3px solid #e3effd;
		border-radius: 50%;

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.summary-title {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;

		h2 {
			margin: 0;
			color: #303846;
			font-size: 21px;
		}

		span {
			padding: 4px 10px;
			border-radius: 13px;
			color: #168653;
			font-size: 12px;
			background: #e3f6ec;
		}
	}

	.summary-copy p {
		margin: 9px 0 0;
		color: #939ba7;
		font-size: 13px;
	}

	.profile-card {
		margin-top: 20px;
		padding: 24px 28px 32px;
	}

	.card-heading {
		padding-bottom: 18px;
		border-bottom: 1px solid #e9edf2;

		h3 {
			margin: 0 0 6px;
			color: #303846;
			font-size: 19px;
		}

		p {
			margin: 0;
			color: #929aa6;
			font-size: 13px;
		}
	}

	.profile-form {
		width: 720px;
		max-width: 100%;
		padding-top: 25px;

		::v-deep .el-form-item {
			margin-bottom: 18px;
		}

		::v-deep .el-form-item__label {
			color: #4c5868;
			font-size: 15px;
			line-height: 42px;
		}
	}

	.form-value {
		display: flex;
		align-items: center;

		.el-input {
			width: 430px;
			max-width: calc(100% - 65px);
			margin-right: 14px;
		}

		::v-deep .el-input__inner {
			height: 42px;
			color: #626d7b;
			background: #f6f8fa;
		}
	}
</style>
